/**
 * Accordion
 * Drawer that slides down with content. Stack multiple Accordions to segregate sections
 * Author: Mayank Gureja
 * Date: 07/04/2019
 * Requires accordion.scss for styling
 */

function setHeight(accordionToggle) {
  const content = accordionToggle.nextElementSibling;
  if (accordionToggle.classList.contains('is-active')) {
    content.style.maxHeight = `${content.scrollHeight}px`;
    setTimeout(() => {
      content.style.overflow = 'visible';
    }, 250);
  } else {
    content.style.maxHeight = null;
    content.style.overflow = 'hidden';
  }
}

const setAccordionHeight = (accordion) => {
  if (accordion) {
    const btn = accordion.querySelector('.accordion-toggle');
    setHeight(btn);
  } else {
    document.querySelectorAll('.accordion-toggle').forEach((btn) => {
      setHeight(btn);
    });
  }
};

const openAccordion = (accordion) => {
  const btn = accordion.querySelector('.accordion-toggle');
  btn.classList.add('is-active');
  setAccordionHeight(accordion);

  const evt = new CustomEvent('accordionopen');
  window.dispatchEvent(evt);
};

const closeAccordion = (accordion) => {
  const btn = accordion.querySelector('.accordion-toggle');
  btn.classList.remove('is-active');
  setAccordionHeight(accordion);

  const evt = new CustomEvent('accordionclose');
  window.dispatchEvent(evt);
};

const toggleAccordion = (accordion) => {
  const btn = accordion.querySelector('.accordion-toggle');

  if (btn.classList.contains('is-active')) {
    closeAccordion(accordion);
    // Remove hash from URL
    window.history.replaceState(null, null, ' ');
  } else {
    openAccordion(accordion);
    // Add hash to URL on clicking for easier switch on reload
    window.location.hash = `section_${[...btn.parentElement.parentElement.children].indexOf(
      btn.parentElement,
    )}`;
  }

  const evt = new CustomEvent('accordiontoggle');
  window.dispatchEvent(evt);
};

// Initialization
if (document.querySelector('.accordion-toggle:not(.is-phx-togglable):not(.is-not-togglable)')) {
  document.querySelectorAll('.accordion').forEach((accordion) => {
    const btn = accordion.querySelector(
      '.accordion-toggle:not(.is-phx-togglable):not(.is-not-togglable)',
    );
    btn.innerHTML += '<span class="icon"><i class="fas fa-chevron-right"></i></span>';

    btn.addEventListener('click', () => {
      toggleAccordion(accordion);
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.accordion').forEach((accordion) => {
      setAccordionHeight(accordion);
    });
  });

  // On page load, if specific section is requested via query hashtag, open it
  const openSection = window.location.hash.replace('#section_', '');
  if (openSection) {
    toggleAccordion(
      document.querySelector('.accordions').children[window.location.hash.replace('#section_', '')],
    );
  } else {
    toggleAccordion(document.querySelector('.accordions').children[0]);
  }
}

window.setAccordionHeight = setAccordionHeight;
